(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["madroots-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('MadrootsWelcomePopup');
    if (!popup || typeof popup.showModal !== 'function') return;

    const closeButton = popup.querySelector('.madroots-welcome-close');
    const success = popup.dataset.success === 'true';
    const hasErrors = popup.dataset.errors === 'true';
    const dismissedKey = 'madrootsWelcomePopupDismissedAt';
    const subscribedKey = 'madrootsWelcomePopupSubscribedAt';
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;

    const closePopup = () => {
      if (popup.open) popup.close();
      localStorage.setItem(dismissedKey, String(Date.now()));
    };

    closeButton?.addEventListener('click', closePopup);
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });

    if (success) {
      localStorage.setItem(subscribedKey, String(Date.now()));
      popup.showModal();
      return;
    }

    if (hasErrors) {
      popup.showModal();
      return;
    }

    if (localStorage.getItem(subscribedKey)) return;

    const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
    if (dismissedAt && Date.now() - dismissedAt < fourteenDays) return;

    window.setTimeout(() => {
      if (!popup.open) popup.showModal();
    }, 7000);
  })();
  } catch(e) { console.error(e); }
})();

})();
